module.exports = __webpack_public_path__ + "static/other/gameLabDiagnosis.fece4fd0.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLabDiagnosis.json
// module id = 2243
// module chunks = 0